import React from 'react';
import { Section } from '../Section';
import { Panel } from '../ui/Panel';
import { Pill } from '../ui/Pill';
import { differently } from '../../data/caseStudy';
const tags = ['Team & hand-off', 'Tooling & cost'];
export function Reflections() {
  return <Section number="08" kicker="Reflection" title="What I’d do differently" lede="Both come down to timing, being in the room earlier, on the decisions that set the constraints." tone="white" data-id="element-151" data-mp="473u98umwr6w">
      <div className="grid grid-cols-2 gap-6" data-id="element-152" data-mp="e2x76tc9mmp7">
        {differently.map((item, i) => <Panel key={item.title} padding="lg" data-id="element-153" data-mp="j0ywvx475k9n" data-mpi={i}>
            <div className="flex items-center justify-between" data-id="element-154" data-mp="nsyqz8xl5iyb">
              <Pill variant="neutral" data-id="element-155" data-mp="nts2en7howms">{tags[i]}</Pill>
              <span className="tabular font-display text-[13px] font-semibold text-green-deep" data-id="element-156" data-mp="rv3ncfff4ton">
                {String(i + 1).padStart(2, '0')}
              </span>
            </div>
            <h3 className="mt-6 font-display text-[24px] font-semibold leading-tight tracking-[-0.02em] text-navy" data-id="element-157" data-mp="11shzw3y80ybo">
              {item.title}
            </h3>
            <p className="mt-4 font-sans text-[15px] leading-[1.8] text-ink-muted" data-id="element-158" data-mp="7kbl34e1fl1n">{item.body}</p>
          </Panel>)}
      </div>
    </Section>;
}